<template>
  <div>
    <b-form-group v-if="allowCreate || (internalValue && internalValue.length > 0)" :label="$t('Webportal.Comments')"
      label-size="sm">
      <comment v-if="allowCreate" :onSend="sendComment" />
    </b-form-group>

    <b-form-group v-for="comment of internalValue" :key="comment.SurveyImprovementCommentId">
      <comment :value="comment" :allow-edit="allowEdit" :allow-delete="allowDelete" :show-modified-hint="allowEdit"
        :onSend="sendComment">
      </comment>
    </b-form-group>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import ActionService from "@/services/ActionService";
import Comment from "./Comment.vue";
import { useToast } from 'bootstrap-vue-next';

export default {
  name: "SurveyImprovementComments",

  mixins: [AppConfig],

  components: { Comment },

  props: {
    surveyImprovementId: { type: Number, default: null },
    surveyImprovementEntryId: { type: Number, default: null },
    modelValue: { type: Array, default: null },
    allowCreate: { type: Boolean, default: false },
    allowEdit: { type: Boolean, default: false },
    allowDelete: { type: Boolean, default: false },
  },

  setup() {
    const { show } = useToast();
    return { showToast: show };
  },

  data() {
    return {
      newCommentText: null,
      internalValue: this.modelValue,
      isBusy: false,
    };
  },

  watch: {
    modelValue(newVal) {
      this.internalValue = newVal;
    },

    internalValue(newVal) {
      this.$emit("update:modelValue", newVal);
    },

    isBusy(newVal) {
      this.$emit("is-busy-changed", newVal);
    },
  },

  methods: {
    async sendComment(comment, newCommentText, isDeleted) {
      this.isBusy = true;

      const isNewComment = comment == null;

      const commentToSubmit = {
        SurveyImprovementCommentId: comment?.SurveyImprovementCommentId,
        SurveyImprovementId: this.surveyImprovementId,
        SurveyImprovementEntryId: this.surveyImprovementEntryId,
        Comment: newCommentText ?? undefined,
        IsDeleted: isDeleted ?? undefined
      };

      try {
        let response = await ActionService.createOrUpdateSurveyImprovementComment(
          this.surveyImprovementId,
          commentToSubmit
        )

        if (!response.data) return Promise.reject();

        if (isNewComment)
          if (this.internalValue)
            this.internalValue.unshift(response.data);
          else
            this.internalValue = [response.data];
        else
          Object.assign(comment, response.data);
      } catch (error) {
        console.error(error);

        this.showToast({
          props: {
            title: this.$t("Webportal.SaveFailed.Text", {
              entity: this.$t("Webportal.Actions.SurveyRevisionComment"),
            }),
            variant: "danger",
            autoHide: true,
            delay: 5000,
          }
        });

        throw error;
      }
      finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
